import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { NOTARY_ENDPOINT } from '../../../../../../utility/SourceAPI'

export const getNotaries = createAsyncThunk('appNotary/getNotaries', async () => {
    const response = await axios.get(NOTARY_ENDPOINT)
    return {
        data: response.data
    }
})

export const addNotary = createAsyncThunk('appNotary/addNotary', async (data) => {
    const response = await axios.post(NOTARY_ENDPOINT, data)
    return {
        data: response.data
    }
})

export const editNotary = createAsyncThunk('appNotary/editNotary', async (data) => {
    const response = await axios.put(`${NOTARY_ENDPOINT}${data.id}`, data)
    return {
        data: response.data
    }
})

export const notarySlice = createSlice({
    name: 'appNotary',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getNotaries.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
    }
})

export default notarySlice.reducer